<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons v-if="!propCambioClave" slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title v-if="!propCambioClave" v-text="'AJUSTES'"></ion-title>
      <ion-title v-else v-text="'CAMBIO DE CLAVE'"></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid v-if="cambioClave && !cargando">
      <h6 v-if="propCambioClave" class="mt-3 text-danger text-center">POR SEGURIDAD DEBE CAMBIAR SU CLAVE ANTES DE CONTINUAR.</h6>
      <ion-row v-if="!propCambioClave" class="mt-3">
          <ion-col>
              <ion-label class="label-form">Clave actual</ion-label>
              <ion-input style="height: 35px!important;" class="rounded rounded-pill border border-dark" type="password" placeholder="********" v-model="claves.claveActual"></ion-input>
          </ion-col>
      </ion-row>
      <ion-row class="mt-4">
          <ion-col>
              <ion-label class="label-form">Clave nueva</ion-label>
              <ion-input style="height: 35px!important;" class="rounded rounded-pill border border-dark" type="password" placeholder="********" v-model="claves.claveNueva1"></ion-input>
          </ion-col>
      </ion-row>
      <ion-row>
          <ion-col>
              <ion-label class="label-form">Reingresa clave nueva</ion-label>
              <ion-input style="height: 35px!important;" class="rounded rounded-pill border border-dark" type="password" placeholder="********" v-model="claves.claveNueva2"></ion-input>
              <ion-label v-if="claves.claveNueva1!=claves.claveNueva2" color="danger" class="ml-3">Las claves no coinciden.</ion-label>
          </ion-col>
      </ion-row>
      <ion-row>
          <ion-col>
            <h6 class="text-center font-weight-bold mt-3">
              <ion-icon slot="icon-only"  name="information-circle-outline"></ion-icon>
              <span class="font-weight-light">
                La nueva clave debe contener mayúsculas, minúsculas y números, con un mínimo de 6 caracteres de largo.
              </span>
            </h6>
          </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid v-if="!cambioClave && !cargando">
      <ion-row class="mb-3 mt-3">
          <ion-col>
              <ion-button color="warning" shape="round" expand="block" @click="cambioClave=true;">
                  <ion-icon name="key-outline"></ion-icon>
                  <ion-label class="ml-2">CAMBIAR CLAVE</ion-label>
              </ion-button>
          </ion-col>
      </ion-row>
      <ion-row class="border-top">
          <ion-col>
              <ion-label class="label-form">Nombre</ion-label>
              <ion-input disabled style="height: 35px!important;" class="rounded shadow rounded-pill border border-dark" type="text" 
                v-bind:value="usuario.usr_nombres+' '+usuario.usr_apellido_p+' '+usuario.usr_apellido_m"></ion-input>
          </ion-col>
      </ion-row>
      <ion-row>
          <ion-col>
              <ion-label class="label-form">Correo</ion-label>
              <ion-input disabled style="height: 35px!important;" class="rounded shadow rounded-pill border border-dark" type="mail" 
                v-bind:value="usuario.usr_correo"></ion-input>
          </ion-col>
      </ion-row>
      <ion-row>
          <ion-col>
              <ion-label class="label-form">Telefono</ion-label>
              <ion-input disabled style="height: 35px!important;" class="rounded shadow rounded-pill border border-dark" type="text" 
                v-bind:value="'+56 '+usuario.usr_telefono"></ion-input>
          </ion-col>
      </ion-row>
      <ion-row class="mt-2">
          <ion-col class="text-center h6" style="font-size:15px;">
              <ion-label color="medium">Si desea modificar alguno de sus datos personales, contacte al area de informatica.</ion-label>
          </ion-col>
      </ion-row>


      <ion-row v-if="![null, ''].includes(usuario.usr_correo)" class=" border-top mt-3 pt-2">
          <ion-col size="8">
              <ion-label class="label-form">Alertas al correo</ion-label>
          </ion-col>
          <ion-col class="text-right">
              <ion-toggle @ionChange="usuario.usr_noti_correo = !usuario.usr_noti_correo" :checked="usuario.usr_noti_correo" style="padding:5px;"></ion-toggle>
          </ion-col>
      </ion-row>
      <ion-row v-if="esMovil && usuario.cantidad_tokens>0" class="pt-2">          
          <ion-col size="8">
              <ion-label class="label-form">Alertas a la APP MOVIL</ion-label>
          </ion-col>
          <ion-col class="text-right">
              <ion-toggle @ionChange="usuario.usr_noti_app = !usuario.usr_noti_app" :checked="usuario.usr_noti_app" style="padding:5px;" ></ion-toggle>
          </ion-col>
      </ion-row>

      <ion-row class="border-top pt-2 mt-2 mb-5">          
          <ion-col size="8">
              <ion-label class="label-form">Modo oscuro</ion-label>
          </ion-col>
          <ion-col class="text-right">
              <ion-toggle @ionChange="usuario.usr_modo_oscuro = !usuario.usr_modo_oscuro" :checked="usuario.usr_modo_oscuro" style="padding:5px;" ></ion-toggle>
          </ion-col>
      </ion-row>

    </ion-grid>
  </ion-content>
  <ion-footer class="bar-stable">
    <ion-grid>
      <ion-row v-if="!cargando && !cambioClave">
          <ion-col>
              <ion-button color="danger" shape="round" expand="block" @click="cerrarModal();">
                  <ion-label>CANCELAR</ion-label>
              </ion-button>
          </ion-col>
          <ion-col>
              <ion-button :disabled="!usuario.usr_correo" @click="modificarAlertas();" color="success" shape="round" expand="block">
                  <ion-label>GUARDAR</ion-label>
              </ion-button>
          </ion-col>
      </ion-row>

      <ion-row v-if="!cargando && cambioClave">
          <ion-col v-if="!propCambioClave">
              <ion-button color="danger" shape="round" expand="block" @click="cambioClave=false;">
                  <ion-label>CANCELAR</ion-label>
              </ion-button>
          </ion-col>
          <ion-col>
              <ion-button :disabled="!validaInputsClave()" @click="modificarClave();" color="success" shape="round" expand="block">
                  <ion-label>CAMBIAR</ion-label>
              </ion-button>
          </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { IonContent, IonHeader, isPlatform, IonTitle, IonToolbar, IonToggle, modalController, IonIcon, IonButton, IonButtons, 
          IonLabel, IonInput, IonGrid, IonCol, IonRow, IonSpinner, toastController, IonFooter } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, add, close, keyOutline, informationCircleOutline } from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import * as CryptoJS from 'crypto-js';
import axios      from 'axios';
import rutaBase   from '@/plugins/variables';

export default defineComponent({
  name: 'Ajustes',
  props: {
    modal: Object,
    propCambioClave: Boolean
  },
  components: { IonContent, IonHeader, IonTitle, IonToolbar, IonToggle, IonIcon, IonButton, IonButtons, 
                IonLabel, IonInput, IonGrid, IonCol, IonRow, IonSpinner, IonFooter },
  data(){
    return {
      cargando      : true,
      cambioClave   : false,
      usuario       : {},
      claves        : {claveActual:'', claveNueva1:'', claveNueva2:''},
      esMovil       : false,
      modoOscuro    : false
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'          : arrowBackOutline,
      'add'                         : add,
      'close'                       : close,
      'key-outline'                 : keyOutline,
      'information-circle-outline'  : informationCircleOutline
    });
  },
  mounted(){
    if(this.propCambioClave){
      this.cambioClave = true;
    }
    this.detectaPlataforma();
    this.listarDatosUsuario();
  },
  methods:{
    detectaPlataforma(){
      if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) || !isPlatform('mobileweb') && !isPlatform('desktop')){
        this.esMovil = true;
      }
      else{
        this.esMovil = false;
      } 
    },
    async listarDatosUsuario(){ 
      this.cargando     = true;
      const rut         = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      dato.append('rut', rut.value);
      axios.post(rutaBase+'/perfil/listarDatosUsuario', dato, headers).then( resp => {
        this.usuario = resp.data.usuario;
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async modificarClave(){
      this.cargando     = true;
      let claveActual   = '';
      if(this.propCambioClave){
        claveActual = (await Preferences.get({ key: 'clave' })).value;
      }
      else {
        claveActual = CryptoJS.SHA1(CryptoJS.MD5(this.usuario.usr_rut.toString()+this.claves.claveActual.toString()).toString()).toString();
      }
      
      const claveNueva  = CryptoJS.SHA1(CryptoJS.MD5(this.usuario.usr_rut.toString()+this.claves.claveNueva1.toString()).toString()).toString();
      const rut         = await Preferences.get({ key: 'rut' });
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      dato.append('rut'           , rut.value);
      dato.append('clave_actual'  , claveActual);
      dato.append('clave_nueva'   , claveNueva);
      axios.post(rutaBase+'/perfil/modificarClave', dato, headers).then( resp => {
        if('resp' in resp.data){
          const mensaje = resp.data.resp;
          if(mensaje.key == 1){
            this.muestraToast('CLAVE CAMBIADA CON ÉXITO.');
            if(this.propCambioClave){
              Preferences.set({ key: 'cambio_clave', value: '0' });
              location.reload();
              this.cerrarModal();
            }
            this.cambioClave   = false;
            this.claves        = {claveActual:'', claveNueva1:'', claveNueva2:''};
          }
          else if(mensaje.key == 2) {
            this.muestraToast('LA CLAVE ACTUAL INGRESADA NO ES CORRECTA.');
          }
          else if(mensaje.key == 0) {
            this.muestraToast('ERROR AL REALIZAR CAMBIOS, INTENTELO MAS TARDE.');
          }
        }
        else {
          this.muestraToast('ERROR AL REALIZAR CAMBIOS, INTENTELO MAS TARDE.');
        }
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async modificarAlertas(){
      this.cargando     = true;
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      dato.append('datos_usuario' , JSON.stringify(this.usuario));
      axios.post(rutaBase+'/perfil/modificarAlertas', dato, headers).then( resp => {
        if('resp' in resp.data){
          const mensaje = resp.data.resp;
          if(mensaje.key == 1){
            this.cambioClave   = false;
            this.cerrarModal();


            const valorModoOscuro = this.usuario.usr_modo_oscuro ? 1:0;
            Preferences.set({key: 'modo_oscuro', value: valorModoOscuro.toString()});

            if (this.usuario.usr_modo_oscuro){
              document.body.classList.add('dark');
            }
            else{
              document.body.classList.remove("dark");
            }

            this.muestraToast('CAMBIOS REALIZADOS CON ÉXITO.');
          }
          else if(mensaje.key == 0) {
            this.muestraToast('ERROR AL REALIZAR CAMBIOS, INTENTELO MÁS TARDE.');
          }
        }
        else {
          this.muestraToast('ERROR AL REALIZAR CAMBIOS, INTENTELO MÁS TARDE.');
        }
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
      
    },

    validaInputsClave(){
      if((this.claves.claveActual != '' || this.cambioClave) && this.claves.claveNueva1 == this.claves.claveNueva2 && this.claves.claveNueva1.length>5 && this.validaClave(this.claves.claveNueva1)){
        return true;
      }
      else {
        return false;
      }
    },

    validaClave(clave){
      const regex = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/;
      if(regex.test(clave) && clave.length > 5){
        return true;
      }
      else {
        return false;
      }
    },

    formateaNumero(numero){
      return new Intl.NumberFormat("de-DE").format(numero)
    },

    async cerrarModal(dato=false){
      modalController.dismiss({recargar: dato});
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000
        })
      return toast.present();
    }
  }
});
</script>

<style scoped>
.input-form input {
    border-radius: 50rem!important;
    border: 1px solid black!important;
    padding: .375rem .85rem!important;
    height: 35px!important;
    /* box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important; */
    text-align: left!important;
    margin-top: 5px;
    color: black!important;
    background-color: white!important;
}

.input-form input:focus {
    border-color: #007bff!important;
}

.textarea-form div textarea {
    border-radius: 50rem!important;
    border: 1px solid black!important;
    padding: .375rem .85rem!important;
    color: black!important;
    background-color: white!important;
}

.textarea-form div textarea:focus {
    border-color: #007bff!important;
}

.label-form {
    padding-left: 10px!important;
}

ion-select {
    border-radius: 50rem!important;
    border: 1px solid black!important;
    padding: .375rem .85rem!important;
    height: 35px!important;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    text-align: left!important;
    margin-top: 5px;
    color: black!important;
    background-color: white!important;
}

</style>
